import React, { useState, useEffect, useContext } from "react";
import "../Stock/tax.css";
import "../Stock/variation.css";
import { Button, Form, Card as CardA } from "react-bootstrap";
import { PostCallWithErrorResponse, putMultipartWithAuthCall, simpleGetCall } from "../../../api/ApiServices";
// import ApiConfig from "../../../api/ApiConfig";
import { AppContext } from "../../../context/AppContext";
import { ToastMsg } from "../../TostMsg";
import { useNavigate, useParams } from "react-router-dom";

export default function StockDetails() {
  // const allCategories = [
  //   { name: "Main Course", rank: 1, id: 1 },
  //   { name: "Rice & Bread", rank: 2, id: 2 },
  //   { name: "Appetizers", rank: 3, id: 3 },
  //   { name: "BBQ & Grills", rank: 4, id: 4 },
  //   { name: "Beverages", rank: 5, id: 5 },
  //   { name: "Desserts", rank: 6, id: 6 },
  // ];

  const [selectedCategories, setSelectedCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { sidebar, selectedStoreID,selectedRestID,ApiConfig } = useContext(AppContext);
  const navigate = useNavigate()
const { id } = useParams();
const [allCategories, setAllCategories] = useState([]); 

  const [printData, setPrintData] = useState({
    kitchen_name: "",
    description: "",
    location: "",
    printer_ip_address: "",
    shop_id: '',
    connection_type: "",
    printer_mac_address: "",
    printer_port: "",
    printer_model: "",
    print_header:"",
    is_default: false,
    is_counter_printer:false,
    counter_printer_types: [],
    client_id: "",
    // category_ids: [],
    product_ids: [],
    categories:[]
    // category_ids: "",
  });



useEffect(() => {
  setPrintData((prev) => ({
    ...prev,
    shop_id: selectedStoreID,
  }));
}, [selectedStoreID,]);



const isPrintDataValid = () => {
  return (

    (printData.printer_ip_address ?? "").trim() !== "" 
    // (printData.printer_port ?? "").trim() !== "" 
   
   

    // Add printer_type check if needed
  );
};



// useEffect(() => {

// }, [printData]);



useEffect(() => {
  const randomClientID = `client_${Math.random().toString(36).substring(2, 10)}`;

  settestData((prev) => ({
    ...prev,
    printerIp: printData.printer_ip_address,
    printerPort: printData.printer_port,
    restID: selectedRestID,
    client_id: printData.client_id
  }));
}, [printData, selectedRestID]);

  const [testData, settestData] = useState({
    restID: "",
    printerIp: "",
    printerPort: "",
    client_id: "",
 
    // printer_type: "",
  });

  
  

// const handleCategoryChange = (categoryName, categoryId) => {

//     setPrintData((prev) => {
//       const currentIds = Array.isArray(prev.category_ids) ? prev.category_ids : [];
//       return {
//         ...prev,
//         category_ids: currentIds.includes(categoryId)
//           ? currentIds.filter((id) => id !== categoryId)
//           : [...currentIds, categoryId],
//       };
//     });
//     setSelectedCategories((prev) => {
//       return prev.includes(categoryName)
//         ? prev.filter((cat) => cat !== categoryName)
//         : [...prev, categoryName];
//     });
//   };


// const handleCategoryChange = (categoryName, categoryId) => {
//   setPrintData((prev) => {
//     const currentIds = Array.isArray(prev?.category_ids)
//       ? prev.category_ids
//       : [];

//     const updatedIds = currentIds.includes(categoryId)
//       ? currentIds.filter((id) => id !== categoryId)
//       : [...currentIds, categoryId];

//     return {
//       ...prev,
//       category_ids: updatedIds,
//     };
//   });

//   setSelectedCategories((prev) =>
//     prev.includes(categoryName)
//       ? prev.filter((cat) => cat !== categoryName)
//       : [...prev, categoryName]
//   );
// };
 




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrintData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // AddPrint();
  };

const AddPrint = () => {
  setLoading(true);


  
  const requestBody = JSON.stringify({ ...printData, shop_id: selectedStoreID, product_ids : selectedItemIds });

  PostCallWithErrorResponse(ApiConfig.ADD_Print, requestBody)
    .then((res) => {
      setLoading(false);
      if (res.json && res.json?.success === true) {
        ToastMsg("success", res.json.message);
        navigate('/StoreManage');
      } else {
        ToastMsg("error", res.json.message);
      }
    })
    .catch((err) => {
      setLoading(false);
      setError("Error adding printer");
      console.log(err);
    });
};

  const updatePrint = () => {
    setLoading(true);
  
 const temp = { ...printData };
temp.category_ids = [];

PostCallWithErrorResponse(
  ApiConfig.Update_Print + id,

  
  JSON.stringify({
    ...printData,
    shop_id: selectedStoreID,
    product_ids : selectedItemIds,
  })
)

      .then((res) => {
        setLoading(false);
        if (res.json && res.json?.success === true) {
        ToastMsg("success", res.json.message);
            navigate('/StoreManage')

        } else {
                     ToastMsg("error", res.json.message);

        }
      })
      .catch((err) => {
        setLoading(false);
        setError("Error updating printer");
        console.log(err);
      });
  };




  useEffect(  () => {
 
    fetchPrintDeteals();

 categoryLookUpFunction()
    // fetchctgList()
    
  }, [selectedStoreID,selectedRestID]);
 
const [categoryLookUp, setCategoryLookUp] = useState([])
  const [defaultSelectedProducts, setDefaultSelectedProducts  ] = useState([]);
useEffect (()=>{
  
      if(defaultSelectedProducts?.length > 0 && categoryLookUp?.length > 0){
        const expandCategory = findCategoryIdsByItemIds(categoryLookUp , defaultSelectedProducts);
     
        setExpandedCategories(expandCategory)
      }
},[defaultSelectedProducts, categoryLookUp ]);


 

  const testPrint = () => {
    setLoading(true);
    PostCallWithErrorResponse(ApiConfig.test_Print, JSON.stringify(  { ...testData, restID: selectedRestID }))
      .then((res) => {
        setLoading(false);
        if (res.json && res.json?.success === true) {
   
        ToastMsg("success", res.json.message);
          
        } else {
           ToastMsg("error", res.json.message);
 
        }
      })
      .catch((err) => {
        setLoading(false);
        setError("Error adding printer");
        console.log(err);
      });
  };







// catgaregore 





 // -----------------------------------------------------
  // 1️⃣ Handle checkbox updates
  // -----------------------------------------------------


  // -----------------------------------------------------
  // 2️⃣ Auto-load already selected categories from printData.categories
  // -----------------------------------------------------
  // useEffect(() => {
  //   if (Array.isArray(printData.categories) && printData.categories.length > 0) {
  //     const names = printData.categories.map((c) => c.category_name);
  //     const ids = printData.categories.map((c) => c.id);

  //     setSelectedCategories(names);
  //     setPrintData((prev) => ({ ...prev, category_ids: ids }));
  //   }
  // }, [printData.categories]);






//OLD code to display categories
//   const [initialCategoriesLoaded, setInitialCategoriesLoaded] = useState(false);

// useEffect(() => {
//   if (
//     !initialCategoriesLoaded &&
//     Array.isArray(printData.categories) &&
//     printData.categories.length > 0
//   ) {
//     const names = printData.categories.map((c) => c.category_name);
//     const ids = printData.categories.map((c) => c.id);

//     setSelectedCategories(names);
//     setPrintData((prev) => ({ ...prev, category_ids: ids }));

//     setInitialCategoriesLoaded(true); // prevent re-running
//   }
// }, [printData.categories, initialCategoriesLoaded]);


  // -----------------------------------------------------
  // 3️⃣ Fetch categories (All categories list)
  // -----------------------------------------------------
  const fetchctgList = async () => {
    setLoading(true);
    try {
      const response = await simpleGetCall(
        // `${ApiConfig.GET_Print_Catagrilist}${selectedStoreID}`
        `${ApiConfig.GET_Catagrilist_Lookup}${selectedStoreID}`
      );
      setLoading(false);

      const apiCats = response.data || [];
      setAllCategories(apiCats);

      // When printData already has category_ids, pre-select
      if (printData.category_ids.length > 0) {
        const selectedNames = apiCats
          .filter((cat) => printData.category_ids.includes(cat.id))
          .map((cat) => cat.category_name);

        setSelectedCategories(selectedNames);
      }
    } catch (err) {
      setLoading(false);
      console.error("Category API Error:", err);
    }
  };


  

   const categoryLookUpFunction = async () => {
    setLoading(true);
    try {
      const response = await simpleGetCall(
       
        `${ApiConfig.GET_Catagrilist_Lookup}${selectedStoreID}`
      );
      setLoading(false);

      const apiCats = response.data || [];
      
      setCategoryLookUp(apiCats);

      // // When printData already has category_ids, pre-select
      // if (printData.category_ids.length > 0) {
      //   const selectedNames = apiCats
      //     .filter((cat) => printData.category_ids.includes(cat.id))
      //     .map((cat) => cat.category_name);

      //   setSelectedCategories(selectedNames);
      // }
    } catch (err) {
      setLoading(false);
      console.error("Category API Error:", err);
    }
  };





  // -----------------------------------------------------
  // 4️⃣ Fetch printer details (includes already-selected categories)

function findCategoryIdsByItemIds(categories, itemIds) {
  const itemIdSet = new Set(itemIds);       // for fast lookup
  const resultCategoryIds = new Set();      // to avoid duplicates

  categories.forEach(category => {
    if (!Array.isArray(category.items)) return;

    const found = category.items.some(item => itemIdSet.has(item.id));

    if (found) {
      resultCategoryIds.add(category.category_id);
    }
  });

  return Array.from(resultCategoryIds);
}


  // -----------------------------------------------------

  const fetchPrintDeteals = async () => {
    setLoading(true);
    try {
      const response = await simpleGetCall(
        `${ApiConfig.GET_Print_detalis}${id}`
      );
      setLoading(false);

      if (response.success) {
        const data = response.data;
       
        setPrintData({
          ...data,
           counter_printer_types: Array.isArray(data.counter_printer_types)
      ? data.counter_printer_types
      : []
          // is_default : types.length === 0 
        });
        const productIds = data?.products?.map(item=> item.id);
        setDefaultSelectedProducts(productIds);

        setSelectedItemIds(productIds)

        // If categories already fetched before this API
        if (allCategories.length > 0) {
          const names = allCategories
            .filter((cat) => data.category_ids.includes(cat.id))
            .map((cat) => cat.category_name);

          setSelectedCategories(names);
        }
      }
    } catch (err) {
      setLoading(false);
      console.error("Printer Details API Error:", err);
    } 
  };


  // const handleCategoryChange = (categoryName, categoryId) => {
  //   // Update selected category names for UI
  //   setSelectedCategories((prev) =>
  //     prev.includes(categoryName)
  //       ? prev.filter((name) => name !== categoryName)
  //       : [...prev, categoryName]
  //   );

  //   // Update category_ids for API
  //   setPrintData((prev) => {
  //     const ids = Array.isArray(prev.category_ids) ? prev.category_ids : [];
  //     const updatedIds = ids.includes(categoryId)
  //       ? ids.filter((id) => id !== categoryId)
  //       : [...ids, categoryId];

  //     return { ...prev, category_ids: updatedIds };
  //   });
  // };

 const handleCategoryChange = (categoryName, categoryId) => {
  const id = Number(categoryId);  // normalize id

  // Update selected category names
  setSelectedCategories((prev) =>
    prev.includes(categoryName)
      ? prev.filter((name) => name !== categoryName)
      : [...prev, categoryName]
  );

  // Update selected IDs in printData
  setPrintData((prev) => {
    const ids = Array.isArray(prev.category_ids)
      ? prev.category_ids.map((n) => Number(n))   // normalize all IDs
      : [];

    return {
      ...prev,
      category_ids: ids.includes(id)
        ? ids.filter((item) => item !== id)       // REMOVE
        : [...ids, id],                            // ADD
    };
  });
};




const handleRemoveCategory = (categoryName, categoryId) => {
  const id = Number(categoryId);

  setSelectedCategories((prev) =>
    prev.filter((name) => name !== categoryName)
  );




  // Update selected IDs in printData
  setPrintData((prev) => {
    const ids = Array.isArray(prev.category_ids)
      ? prev.category_ids.map((n) => Number(n))   // normalize all IDs
      : [];

    return {
      ...prev,
      category_ids: ids.includes(id)
        ? ids.filter((item) => item !== id)       // REMOVE
        : [...ids, id],                            // ADD
    };
  });
};


useEffect(() => {
  if (Array.isArray(printData.categories)) {
    const names = printData.categories.map((c) => c.category_name);
    setSelectedCategories(names);
  }
}, [printData.categories]);





const mergedCategories = React.useMemo(() => {
  const all = Array.isArray(allCategories) ? allCategories : [];
  const selected = Array.isArray(printData?.categories) ? printData.categories : [];

  // Normalize all categories (ID to number)
  const normalizedAll = all.map(cat => ({
    ...cat,
    id: Number(cat.id),
    category_name: cat.category_name?.trim()
  }));

  // Build ID & Name lookup sets for fast detection
  const idSet = new Set(normalizedAll.map(c => c.id));
  const nameSet = new Set(normalizedAll.map(c => c.category_name?.trim()));

  // Start with allCategories
  const result = [...normalizedAll];

  // Add selected categories only if not duplicate
  selected.forEach(sel => {
    const selId = Number(sel.id);
    const selName = sel.category_name?.trim();

    const idExists = idSet.has(selId);
    const nameExists = nameSet.has(selName);

    // If neither ID nor name exists → it's a new category
    if (!idExists && !nameExists) {
      result.push({
        ...sel,
        id: selId,
        category_name: selName
      });
    }
  });

  return result;
}, [allCategories, printData]);





////////////////////////////////NEW CATEGORY LOOKUP CODE ////////////////////////////////////////////////////////////// taleeb
 const [selectedItemIds, setSelectedItemIds] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState([]);

  const toggleCategoryExpand = (categoryId) => {
    setExpandedCategories((prev) =>
      prev.includes(categoryId)
        ? prev.filter((id) => id !== categoryId)
        : [...prev, categoryId]
    );
  };

  const handleItemChange = (itemId) => {
    setSelectedItemIds((prev=[]) =>
      prev?.includes(itemId)
        ? prev?.filter((id) => id !== itemId)
        : [...prev, itemId]
    );
  };

  const handleCategoryChange2 = (category) => {
    const itemIds = category.items.map((item) => item.id);

    const allSelected = itemIds.every((id) =>
      selectedItemIds?.includes(id)
    );

   
    setSelectedItemIds((prev=[]) =>
      allSelected
        ? prev?.filter((id) => !itemIds.includes(id))
        : [...new Set([...(prev || []), ...itemIds])]
    );
  };

  const isCategoryChecked = (category) =>
    category?.items?.every((item) =>
      selectedItemIds?.includes(item.id)
    );



   const toggleCounterPrinter = (type) => {
  setPrintData((prev) => {
    let updatedTypes = [...prev?.counter_printer_types || []];
  

    if (updatedTypes?.includes(type)) {
      // Remove
      updatedTypes = updatedTypes?.filter((t) => t !== type);
    } else {
      // Add
      updatedTypes?.push(type);
    }

    return {
      ...prev,
    
      counter_printer_types: updatedTypes,
      is_default: false, 
    };
  });
};



const toggleDefaultPrinter = () => {
  setPrintData((prev) => ({
    ...prev,
    is_default: !prev.is_default ,
    counter_printer_types: [] // clear all counters
  }));
};

  return (
    <div id="cx-main">
      <div className="role-content">
        <div className="sub-header-role">
          <h6 className="mt-2">kitchen management</h6>
        </div>
        <div className="innerRoleSec">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-4">
                <h6 style={{ textAlign: "center" }}>
                  <b>Basic Information</b>
                </h6>
                <Form className="mt-4" onSubmit={handleSubmit}>
                  <Form.Group>
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Restaurant ID
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="shop_id"
                      value={printData.shop_id}
                      disabled
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Kitchen Name
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="kitchen_name"
                      value={printData.kitchen_name}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "100px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      name="description"
                      value={printData.description}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Location
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="location"
                      value={printData.location}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Client ID
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="client_id"
                      value={printData.client_id}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
                   
            <Form.Group className="mt-3">

  {/* DEFAULT PRINTER */}
  <Form.Check
    type="checkbox"
    id="default"
    label="Default Printer"
    checked={printData?.is_default}
    onChange={toggleDefaultPrinter}
  />

  {/* PARCEL */}
  <Form.Check
    type="checkbox"
    id="parcel"
    label="Parcel Counter Printer"
    checked={printData?.counter_printer_types?.includes("P")}
    onChange={() => toggleCounterPrinter("P")}
  />

  {/* DINING */}
  <Form.Check
    type="checkbox"
    id="dining"
    label="Dining Counter Printer"
    checked={printData?.counter_printer_types?.includes("D")}
    onChange={() => toggleCounterPrinter("D")}
  />

  {/* DELIVERY */}
  <Form.Check
    type="checkbox"
    id="delivery"
    label="Delivery Counter Printer"
    checked={printData?.counter_printer_types?.includes("H")}
    onChange={() => toggleCounterPrinter("H")}
  />

</Form.Group>
                </Form>
              </div>
              <div className="col-md-4">
                <h6 style={{ textAlign: "center" }}>
                  <b>Printer Configuration</b>
                </h6>
                <Form className="mt-4">
                  <Form.Group>
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Printer IP Address
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="printer_ip_address"
                      value={printData.printer_ip_address}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
               
                  <Form.Group className="mt-3">
                    <Form.Label className="mb-2 enter-role-text" style={{ fontSize: "14px" }}>
                      Connection Type
                    </Form.Label>
                    <Form.Select
                      className="form-control tasKCategory1"
                      required
                      name="connection_type"
                      value={printData.connection_type}
                      onChange={handleInputChange}
                    >
                      <option disabled value="">
                        Select
                      </option>
                      <option value="network">Network</option>
                      <option value="bluetooth">Bluetooth</option>
                 
                    </Form.Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Connection Type.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-3" style={{marginBottom:'4.9rem'}}>
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Printer Mac Address
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="printer_mac_address"
                      value={printData.printer_mac_address}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>

                  
                  <Form.Group className="mt-3" >
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Printer Port
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="number"
                      name="printer_port"
                      value={printData.printer_port}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group className="mt-3">
                    <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                      Printer Model
                    </Form.Label>
                    <Form.Control
                      className="date-label-input tasKCategory1"
                      style={{
                        fontSize: "14px",
                        height: "38px",
                        border: "1px solid #ced4da",
                      }}
                      required
                      type="text"
                      name="printer_model"
                      value={printData.printer_model}
                      onChange={handleInputChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      Please Fill.
                    </Form.Control.Feedback>
                  </Form.Group>

                      <Form.Group className="mt-3">
                      <Form.Label className="mb-2" style={{ fontSize: "14px" }}>
                        Print Header
                      </Form.Label>
                      <Form.Control
                        className="date-label-input tasKCategory1"
                        style={{
                          fontSize: "14px",
                          height: "38px",
                          border: "1px solid #ced4da",
                        }}
                        required
                        type="text"
                        name="print_header"
                        value={printData.print_header}
                        onChange={handleInputChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Fill.
                      </Form.Control.Feedback>
                    </Form.Group>
                </Form>
              </div>
              <div
                className="col-md-4"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
     <div
      style={{
        border: "1px solid #ccc",
        padding: "16px",
        borderRadius: "8px",
        fontFamily: "Arial",
        width: "100%",
      }}
    >
      <h6 style={{ fontWeight: "bold" }}>Assign Menu Categories</h6>
      <p style={{ marginBottom: "8px" }}>Available Categories:</p>

      {/* All Categories Checkboxes */}
      {/* {(Array.isArray(mergedCategories ) ? mergedCategories  : []).map((cat) => {
        // const checked =
        //   selectedCategories.includes(cat.category_name) ||
        //   printData?.category_ids?.includes(cat.id);
// const checked =
//   selectedCategories.includes(cat.category_name) ||
//   printData?.category_ids?.includes(cat.id);

const checked =
  selectedCategories.includes(cat.category_name)
  //  ||
  // printData?.category_ids?.map(Number).includes(Number(cat.id));


        return (
          <div
            key={cat.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "4px",
            }}
          >
            <Form.Check
              type="checkbox"
              id={cat.id}
              label={cat.category_name}
              checked={checked}
              onChange={() =>
                handleCategoryChange(cat.category_name, cat.id)
              }
            />
          </div>
        );
      })} */}



         <div className="lookup-category-container">
          {categoryLookUp?.map((categoryLookUp) =>(
                <CardA className="lookup-category-card mb-2" key={categoryLookUp.category_id} style={{padding: '4px' }}>
        <CardA.Body style={{padding: '4px' }}>
          {/* CATEGORY HEADER */}
          <div
            className="lookup-category-header"
            onClick={() => toggleCategoryExpand(categoryLookUp.category_id)}
          >
            <Form.Check
              type="checkbox"
              checked={isCategoryChecked(categoryLookUp)}
              onChange={(e) => {
                e.stopPropagation();
                handleCategoryChange2(categoryLookUp);
              }}
              onClick={(e) => e.stopPropagation()}
              className="lookup-category-checkbox"
            />

            <span className="lookup-category-title">
              {categoryLookUp.category_name}
            </span>

            <span className="lookup-expand-icon">
              {expandedCategories.includes(categoryLookUp.category_id) ? "−" : "+"}
            </span>
          </div>

          {/* ITEM LIST */}
          {expandedCategories?.includes(categoryLookUp.category_id) && (
            <div className="lookup-item-list">
              {categoryLookUp?.items?.map((item) => (
                <div key={item.id} className="lookup-item-row">
                  <Form.Check
                    type="checkbox"
                    checked={selectedItemIds?.includes(item.id)}
                    onChange={() => handleItemChange(item.id)}
                  />
                  <span className="lookup-item-name">{item.item_name}</span>
                </div>
              ))}
            </div>
          )}
        </CardA.Body>
      </CardA>
          ))}
   

      {/* DEBUG (remove later) */}
      {/* <div className="lookup-selected-debug">
        <strong>Selected Item IDs:</strong>{" "}
        {JSON.stringify(selectedItemIds)}
      </div> */}
    </div> 
    {/* taleeb */}

      {/* Selected preview */}
     {/* Selected Categories Panel */}
{/* <div
  style={{
    background: "#e6f4ea",
    border: "1px solid #a3d3a1",
    padding: "10px",
    borderRadius: "5px",
    marginTop: "10px",
  }}
>
  <strong>Selected Categories ({selectedCategories.length}):</strong>
  


  <ul style={{ paddingLeft: "16px", marginBottom: 0 }}>
    {selectedCategories.map((catName) => {
      const catObj = mergedCategories.find((c) => c.category_name === catName);
     

      return (
        <li key={catName} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>{catName}</span>
          <button
            style={{
              background: "red",
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "2px 8px",
              cursor: "pointer",
              marginLeft: "10px",
              margin:"5px"
            }}
            onClick={() => handleRemoveCategory(catName, catObj?.id)}
          >
            X
          </button>
        </li>
      );
    })}
  </ul>

  <small style={{ color: "gray" }}>
    Categories will be auto-assigned to this kitchen
  </small>
</div> */}


   
      <Button
        variant="info"
        className="w-100 mt-3"
        style={{
          backgroundColor: "rgb(83 184 232)",
          border: "none",
          color: "white",
          opacity: isPrintDataValid() ? 1 : 0.5,
          cursor: isPrintDataValid() ? "pointer" : "not-allowed",
        }}
        onClick={testPrint}
        disabled={!isPrintDataValid()}
      >
        Test Printer Connection
      </Button>

  
      <div
        style={{
          backgroundColor: "#fff3cd",
          padding: "10px",
          borderRadius: "5px",
          marginTop: "10px",
          border: "1px solid #ffeeba",
          fontSize: "14px",
        }}
      >
        <strong>Kitchen Preview:</strong>
        <div>ID: Auto-generated</div>
        <div>Created: Today</div>
        {/* <div>Status: {printData.is_default ? "Default" : "Not Default"}</div>
        <div>Status Parcel counter printer: {printData.is_counter_printer ? "Default" : "Not Default"}</div> */}
      </div>
    </div>

              </div>
            </div>
            <div className="my-3 d-flex justify-content-end gap-2">
              <button
                className="allocateionBtn"
                style={{ width: "100px" }}
                onClick={ id ? updatePrint : AddPrint}
                disabled={loading}
              >
                {id ? "Update" : "Add"}
              </button>
             
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
}